'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'account_blocked',
    modelClass: require('./model'),
    viewClass: require('./view'),
});
